var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Divider, FormControlLabel, Grid, Skeleton, Switch, Typography, styled, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { UploadImage } from '../../../api/api';
import { Config } from '../../../api/config';
import { USER_PROFILE_DATA, getDownloadJobCardDocumentAttachmentUrl, getFIObservationData, jobCardAttachmentCreateUrl, jobCardGetDetailAPI, precheckDynamicCheckListFormUrl, saveFIObservationDataUrl } from '../../../api/url';
import { MuiBorderBottom, MuiStack } from '../../../components';
import CustomeAccordianWithButton from '../../../components/atoms/customAccordianWithButton';
import HeaderDetails from '../../../components/atoms/headerDetails';
import { MuiLoaderButton } from '../../../components/atoms/loaderButton';
import SkeletonLoader from '../../../components/atoms/sketeton';
import { NoRowsOverlay } from '../../../components/molecules/dataGridComponent';
import UnsavedChangesPopup from '../../../components/molecules/unsavedChangesPopup';
import { FinalInspectorObservation } from '../../../components/templates/finalInspectorObservation';
import { APISchema, EFIChecklistKeys, EFIChecklistParent, EFIJobCardDetailKeys, EFinalInspectorModuleSection, EParentModuleName, ESectionAttributeValue, FITaskDetailsButtonVariant, LOCAL_STORAGE_KEYS, Module, StatusEnum, isModuleConfig } from '../../../constants';
import { downloadAttachment, setTasksDetailsIsDisable, setUpdatedModuleSectionByChannel, showLoader, showNotification } from '../../../redux/commonSlice';
import { createAPI, getByIdAPI, getListAPI, setState, updateAPI } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { bajajPrimaryBlue } from '../../../theme/palette';
import { systemColor } from '../../../theme/systemColor';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import RoadTestComponent from '../../commonViews/taskDetails/taskDetailsCommonComponent/roadTestComponent';
import FinalInspectorSendBackPopup from './finalInspector.SendBackPopup';
import FinalInspectorAdditionalJobs from './finalInspector.additionalJobs';
import FinalInspectorCustomerComplaint from './finalInspector.customerComplaint';
import FinalInspectorDynamicChecklist from './finalInspector.dynamicChecklist';
import FinishInspectionPopup from './finishInspectionPopup';
var IOSSwitch = styled(function (props) { /*#__PURE__*/ return React.createElement(Switch, _extends({
    focusVisibleClassName: ".Mui-focusVisible",
    disableRipple: true
}, props)); })(function (_ref) {
    var theme = _ref.theme;
    return {
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? bajajPrimaryBlue : bajajPrimaryBlue,
                    opacity: 1,
                    border: 0
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5
                }
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff'
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
            }
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500
            })
        }
    };
});
var MyImg = styled("img")(function (_ref2) {
    var theme = _ref2.theme;
    return {
        height: "48px",
        marginRight: "5px",
        width: "48px"
    };
});
var InitialFIChecklistItemChange = {
    customerComplaints: {
        isItemRejected: false,
        isSaveClick: false
    },
    periodicMaintanance: {
        isItemRejected: false,
        isSaveClick: false
    },
    standardJobs: {
        isItemRejected: false,
        isSaveClick: false
    },
    additionalJobs: {
        isItemRejected: false,
        isSaveClick: false
    },
    staticFIChecklist: {
        isItemRejected: false,
        isSaveClick: false
    },
    dynamicFIChecklist: {
        isItemRejected: false,
        isSaveClick: false
    },
    fastnerCheklist: {
        isItemRejected: false,
        isSaveClick: false
    },
    roadTest: {
        isItemRejected: false,
        isSaveClick: false
    }
};
var FinalInspectorTaskDetails = function () {
    var _documentDetailsGetBy, _userData$data, _documentDetailsGetBy2, _userData$data2, _documentDetailsGetBy3, _documentDetailsGetBy4, _documentDetailsGetBy5, _documentDetailsGetBy6, _documentDetailsGetBy7, _documentDetailsGetBy8, _documentDetailsGetBy9, _FIObservationDetails, _getFIButtonDetails, _getFIButtonDetails2, _getFIButtonDetails3, _getFIButtonDetails4, _documentDetailsGetBy10;
    var jobCardId = useParams().jobCardId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var updatedModuleSectionByChannel = useSelector(function (state) { return state.common; }).updatedModuleSectionByChannel;
    var _a = useAppSelector(function (state) { return state.crud; }), FIChecklistItemChange = _a.FIChecklistItemChange, documentDetailsGetById = _a.documentDetailsGetById, FinalInspectionChecklistCount = _a.FinalInspectionChecklistCount, finalInspectorObservationDetails = _a.finalInspectorObservationDetails;
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var skeletonArray = Array.from({
        length: 4
    });
    var _b = useState(false), allswitchEnabled = _b[0], setAllSwitchEnabled = _b[1];
    var _c = useState(false), standardJobApiCall = _c[0], setStandardJobApiCall = _c[1];
    var _d = useState(false), addiotionalJobApiCall = _d[0], setAddiotionalJobApiCall = _d[1];
    var _e = useState(false), dynamicChecklistApiCall = _e[0], setDynamicChecklistApiCall = _e[1];
    var _f = useState(false), staticFIChecklistApiCall = _f[0], setStaticFIChecklistApiCall = _f[1];
    var _g = useState(false), fastnerChecklistApiCall = _g[0], setFastnerChecklistApiCall = _g[1];
    var _h = useState(false), roadTestApiCall = _h[0], setRoadTestApiCall = _h[1];
    var _j = useState(false), periodicMaintainanceApiCall = _j[0], setPeriodicMaintainanceApiCall = _j[1];
    var _k = useState(false), customerComplaintApiCall = _k[0], setCustomerComplaintApiCall = _k[1];
    var _l = useState(false), openPopup = _l[0], setOpenPopup = _l[1];
    var _m = useState(false), openSendBackPopup = _m[0], setOpenSendBackPopup = _m[1];
    var _o = useState({
        Observation: "",
        FinalInspectorId: ""
    }), FIObservationDetails = _o[0], setFIObservationDetails = _o[1];
    var _p = useState([]), staticFIChecklist = _p[0], setStaticFIChecklist = _p[1];
    var _q = useState([]), dynamicFIChecklist = _q[0], setDynamicFIChecklist = _q[1];
    var _r = useState([]), fastenerChecklist = _r[0], setFastenerChecklist = _r[1];
    var _s = useState([]), FIObservationImages = _s[0], setFIObservationImages = _s[1];
    var _t = useState(null), FIObservationaudios = _t[0], setFIObservationAudios = _t[1];
    // const [totalChecklistCount, setTotalChecklistCount] = useState<number>(0);
    // const [approvedChecklitsCount, setApprovedChecklitsCount] = useState<number>(0);
    var _u = useState(false), finishInspectionPopup = _u[0], setFinishInspectionPopup = _u[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var upSM = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var dowMd = useMediaQuery(function (theme) { return theme.breakpoints.down("md"); });
    var IS_TABLET = upSM && dowMd;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var contentRef = useRef(null);
    var _v = useState(0), contentHeight = _v[0], setContentHeight = _v[1];
    var isLoggedInUserIsAssignedFI = (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.FinalInspectorId) === (userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.IdentityId) || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.FinalInspectorId) === (userData === null || userData === void 0 || (_userData$data2 = userData.data) === null || _userData$data2 === void 0 ? void 0 : _userData$data2.EmployeeId);
    var isViewOnly = [StatusEnum.InspectionCompleted, StatusEnum.ReadyForInvoice, StatusEnum.Invoiced, StatusEnum.Delivered].includes(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy3 = documentDetailsGetById.data) === null || _documentDetailsGetBy3 === void 0 ? void 0 : _documentDetailsGetBy3.Key) || !isLoggedInUserIsAssignedFI;
    useEffect(function () {
        documentDetailsDetails();
        getFIObservation();
        return function () {
            setAllSwitchEnabled(false);
            setAddiotionalJobApiCall(false);
        };
    }, []);
    var getJCDetailFIResponse = function () { return __awaiter(void 0, void 0, void 0, function () {
        var body, answersResponse, _answersResponse$payl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: jobCardId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCardDetailFinalInspectionResponse/JobCardDetailFIResponse"),
                            request: body
                        }))];
                case 1:
                    answersResponse = _a.sent();
                    if (answersResponse.payload.success && Array.isArray(answersResponse.payload.data)) {
                        return [2 /*return*/, answersResponse !== null && answersResponse !== void 0 && (_answersResponse$payl = answersResponse.payload) !== null && _answersResponse$payl !== void 0 && _answersResponse$payl.data ? answersResponse.payload.data : []];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getSavedAdditionalJobsList = function (allSaved) { return __awaiter(void 0, void 0, void 0, function () {
        var _additionalJobResult$, body, additionalJobResult, _additionalJobResult$2, _additionalJobResult$3, masterList, savedAdditional_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: jobCardId,
                        Key: EFIJobCardDetailKeys.ADDITIONAL_JOBS
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCardDetail/ByKey"),
                            request: body
                        }))];
                case 1:
                    additionalJobResult = _a.sent();
                    if (additionalJobResult.payload.success && (_additionalJobResult$ = additionalJobResult.payload.data) !== null && _additionalJobResult$ !== void 0 && _additionalJobResult$.Jobs) {
                        masterList = (_additionalJobResult$2 = additionalJobResult.payload.data) !== null && _additionalJobResult$2 !== void 0 && _additionalJobResult$2.Jobs ? (_additionalJobResult$3 = additionalJobResult.payload.data) === null || _additionalJobResult$3 === void 0 ? void 0 : _additionalJobResult$3.Jobs : {};
                        savedAdditional_1 = [];
                        masterList.map(function (masterItem) {
                            var matchedItem = allSaved.find(function (savedItem) { return savedItem.JobCardDetailId === masterItem.JobCardDetailId; });
                            if (matchedItem) {
                                savedAdditional_1.push(matchedItem);
                            }
                        });
                        return [2 /*return*/, savedAdditional_1];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getSavedPmParts = function (allSaved) { return __awaiter(void 0, void 0, void 0, function () {
        var _answersResponse$payl2, body, answersResponse, _answersResponse$payl3, _answersResponse$payl4, masterList, savedPm_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: jobCardId,
                        Key: EFIJobCardDetailKeys.PERIODIC_MAINTENANCE
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCardDetail/ByKey"),
                            request: body
                        }))];
                case 1:
                    answersResponse = _a.sent();
                    if (answersResponse.payload.success && (_answersResponse$payl2 = answersResponse.payload.data) !== null && _answersResponse$payl2 !== void 0 && _answersResponse$payl2.Jobs) {
                        masterList = (_answersResponse$payl3 = answersResponse.payload.data) !== null && _answersResponse$payl3 !== void 0 && _answersResponse$payl3.Jobs ? (_answersResponse$payl4 = answersResponse.payload.data) === null || _answersResponse$payl4 === void 0 ? void 0 : _answersResponse$payl4.Jobs : {};
                        savedPm_1 = [];
                        masterList.map(function (masterItem) {
                            var matchedItem = allSaved.find(function (savedItem) { return savedItem.JobCardDetailId === masterItem.JobCardDetailId; });
                            if (matchedItem) {
                                savedPm_1.push(matchedItem);
                            }
                        });
                        return [2 /*return*/, savedPm_1];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getSavedStandardJobs = function (allSaved) { return __awaiter(void 0, void 0, void 0, function () {
        var _answersResponse$payl5, body, answersResponse, _answersResponse$payl6, _answersResponse$payl7, masterList, savedStandard_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: jobCardId,
                        Key: EFIJobCardDetailKeys.STANDARD_JOBS
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCardDetail/ByKey"),
                            request: body
                        }))];
                case 1:
                    answersResponse = _a.sent();
                    if (answersResponse.payload.success && (_answersResponse$payl5 = answersResponse.payload.data) !== null && _answersResponse$payl5 !== void 0 && _answersResponse$payl5.Jobs) {
                        masterList = (_answersResponse$payl6 = answersResponse.payload.data) !== null && _answersResponse$payl6 !== void 0 && _answersResponse$payl6.Jobs ? (_answersResponse$payl7 = answersResponse.payload.data) === null || _answersResponse$payl7 === void 0 ? void 0 : _answersResponse$payl7.Jobs : {};
                        savedStandard_1 = [];
                        masterList.map(function (masterItem) {
                            var matchedItem = allSaved.find(function (savedItem) { return savedItem.JobCardDetailId === masterItem.JobCardDetailId; });
                            if (matchedItem) {
                                savedStandard_1.push(matchedItem);
                            }
                        });
                        return [2 /*return*/, savedStandard_1];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getSavedComplaints = function () { return __awaiter(void 0, void 0, void 0, function () {
        var body, savedRejectedComplaintResponse, _savedRejectedComplai, _savedRejectedComplai2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: jobCardId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobItemFinalInspectionResponse/JobItemFIResponse"),
                            request: body
                        }))];
                case 1:
                    savedRejectedComplaintResponse = _a.sent();
                    if (savedRejectedComplaintResponse.payload.success && savedRejectedComplaintResponse.payload.data) {
                        return [2 /*return*/, savedRejectedComplaintResponse !== null && savedRejectedComplaintResponse !== void 0 && (_savedRejectedComplai = savedRejectedComplaintResponse.payload) !== null && _savedRejectedComplai !== void 0 && _savedRejectedComplai.data ? savedRejectedComplaintResponse === null || savedRejectedComplaintResponse === void 0 || (_savedRejectedComplai2 = savedRejectedComplaintResponse.payload) === null || _savedRejectedComplai2 === void 0 ? void 0 : _savedRejectedComplai2.data : []];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getSavedDynamicChecklist = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var body, allCheckListSavedData, returnData, _dynamicChecklistMast, _dynamicChecklistMast2, _fastnercChecklistMas, _fastnercChecklistMas2, _StaticChecklistMaste, _StaticChecklistMaste2, _allCheckListSavedDat, _allCheckListSavedDat2, DynamicRequestBody, dynamicChecklistMaster_1, FastnerRequestBody, fastnercChecklistMaster_1, StaticRequestBody, StaticChecklistMaster_1, dynamicSaved_1, fastenerSaved_1, staticSaved_1, allDynamic_1, allFastner_1, allStatic_1, _dynamicChecklistMast3, AllQuestions, _fastnercChecklistMas3, AllQuestions, _StaticChecklistMaste3, AllQuestions, _allCheckListSavedDat3, dynamicApprovedCount, dynamicRejectedCount, dynamicTotalCount, fastnerApprovedCount, fastnerRejectedCount, fastnerTotalCount, staticApprovedCount, staticRejectedCount, staticTotalCount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: jobCardId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "FinalInspectionCheckList/FICheckList"),
                            request: body
                        }))];
                case 1:
                    allCheckListSavedData = _a.sent();
                    returnData = {
                        dynamicApprovedCount: 0,
                        dynamicRejectedCount: 0,
                        dynamicTotalCount: 0,
                        fastnerApprovedCount: 0,
                        fastnerRejectedCount: 0,
                        fastnerTotalCount: 0,
                        staticApprovedCount: 0,
                        staticRejectedCount: 0,
                        staticTotalCount: 0
                    };
                    if (!(allCheckListSavedData.payload.success && allCheckListSavedData.payload.data && allCheckListSavedData.payload.data.Options)) return [3 /*break*/, 5];
                    DynamicRequestBody = {
                        "SystemName": EFIChecklistKeys.DynamicChecklist,
                        "ChildId": productId,
                        "ProductId": productId,
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: precheckDynamicCheckListFormUrl,
                            request: DynamicRequestBody
                        }))];
                case 2:
                    dynamicChecklistMaster_1 = _a.sent();
                    FastnerRequestBody = {
                        "SystemName": EFIChecklistKeys.FastnerChecklist,
                        "ChildId": productId,
                        "ProductId": productId,
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: precheckDynamicCheckListFormUrl,
                            request: FastnerRequestBody
                        }))];
                case 3:
                    fastnercChecklistMaster_1 = _a.sent();
                    StaticRequestBody = {
                        "SystemName": EFIChecklistKeys.StaticChecklist,
                        "ChildId": productId,
                        "ProductId": productId,
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: precheckDynamicCheckListFormUrl,
                            request: StaticRequestBody
                        }))];
                case 4:
                    StaticChecklistMaster_1 = _a.sent();
                    dynamicSaved_1 = [];
                    fastenerSaved_1 = [];
                    staticSaved_1 = [];
                    allDynamic_1 = [];
                    allFastner_1 = [];
                    allStatic_1 = [];
                    if ((_dynamicChecklistMast = dynamicChecklistMaster_1.payload.value) !== null && _dynamicChecklistMast !== void 0 && _dynamicChecklistMast.success && (_dynamicChecklistMast2 = dynamicChecklistMaster_1.payload.value) !== null && _dynamicChecklistMast2 !== void 0 && _dynamicChecklistMast2.data) {
                        AllQuestions = (_dynamicChecklistMast3 = dynamicChecklistMaster_1.payload.value) === null || _dynamicChecklistMast3 === void 0 ? void 0 : _dynamicChecklistMast3.data.flatMap(function (obj) { return obj.Questions ? obj.Questions : []; });
                        allDynamic_1 = AllQuestions;
                    }
                    if ((_fastnercChecklistMas = fastnercChecklistMaster_1.payload.value) !== null && _fastnercChecklistMas !== void 0 && _fastnercChecklistMas.success && (_fastnercChecklistMas2 = fastnercChecklistMaster_1.payload.value) !== null && _fastnercChecklistMas2 !== void 0 && _fastnercChecklistMas2.data) {
                        AllQuestions = (_fastnercChecklistMas3 = fastnercChecklistMaster_1.payload.value) === null || _fastnercChecklistMas3 === void 0 ? void 0 : _fastnercChecklistMas3.data.flatMap(function (obj) { return obj.Questions ? obj.Questions : []; });
                        allFastner_1 = AllQuestions;
                    }
                    if ((_StaticChecklistMaste = StaticChecklistMaster_1.payload.value) !== null && _StaticChecklistMaste !== void 0 && _StaticChecklistMaste.success && (_StaticChecklistMaste2 = StaticChecklistMaster_1.payload.value) !== null && _StaticChecklistMaste2 !== void 0 && _StaticChecklistMaste2.data) {
                        AllQuestions = (_StaticChecklistMaste3 = StaticChecklistMaster_1.payload.value) === null || _StaticChecklistMaste3 === void 0 ? void 0 : _StaticChecklistMaste3.data.flatMap(function (obj) { return obj.Questions ? obj.Questions : []; });
                        allStatic_1 = AllQuestions;
                    }
                    if (allCheckListSavedData !== null && allCheckListSavedData !== void 0 && (_allCheckListSavedDat = allCheckListSavedData.payload) !== null && _allCheckListSavedDat !== void 0 && (_allCheckListSavedDat = _allCheckListSavedDat.data) !== null && _allCheckListSavedDat !== void 0 && _allCheckListSavedDat.Options && (allCheckListSavedData === null || allCheckListSavedData === void 0 || (_allCheckListSavedDat2 = allCheckListSavedData.payload) === null || _allCheckListSavedDat2 === void 0 || (_allCheckListSavedDat2 = _allCheckListSavedDat2.data) === null || _allCheckListSavedDat2 === void 0 || (_allCheckListSavedDat2 = _allCheckListSavedDat2.Options) === null || _allCheckListSavedDat2 === void 0 ? void 0 : _allCheckListSavedDat2.length) > 0) {
                        (_allCheckListSavedDat3 = allCheckListSavedData.payload.data.Options) === null || _allCheckListSavedDat3 === void 0 || _allCheckListSavedDat3.map(function (savedItem) {
                            var _dynamicChecklistMast4, _dynamicChecklistMast5, _fastnercChecklistMas4, _fastnercChecklistMas5, _StaticChecklistMaste4, _StaticChecklistMaste5;
                            if ((_dynamicChecklistMast4 = dynamicChecklistMaster_1.payload.value) !== null && _dynamicChecklistMast4 !== void 0 && _dynamicChecklistMast4.success && (_dynamicChecklistMast5 = dynamicChecklistMaster_1.payload.value) !== null && _dynamicChecklistMast5 !== void 0 && _dynamicChecklistMast5.data) {
                                var matchItem = allDynamic_1.find(function (item) { return item.QuestionId === savedItem.QuestionId; });
                                if (matchItem) {
                                    dynamicSaved_1.push(savedItem);
                                }
                            }
                            if ((_fastnercChecklistMas4 = fastnercChecklistMaster_1.payload.value) !== null && _fastnercChecklistMas4 !== void 0 && _fastnercChecklistMas4.success && (_fastnercChecklistMas5 = fastnercChecklistMaster_1.payload.value) !== null && _fastnercChecklistMas5 !== void 0 && _fastnercChecklistMas5.data) {
                                var matchItem = allFastner_1.find(function (item) { return item.QuestionId === savedItem.QuestionId; });
                                if (matchItem) {
                                    fastenerSaved_1.push(savedItem);
                                }
                            }
                            if ((_StaticChecklistMaste4 = StaticChecklistMaster_1.payload.value) !== null && _StaticChecklistMaste4 !== void 0 && _StaticChecklistMaste4.success && (_StaticChecklistMaste5 = StaticChecklistMaster_1.payload.value) !== null && _StaticChecklistMaste5 !== void 0 && _StaticChecklistMaste5.data) {
                                var matchItem = allStatic_1.find(function (item) { return item.QuestionId === savedItem.QuestionId; });
                                if (matchItem) {
                                    staticSaved_1.push(savedItem);
                                }
                            }
                        });
                    }
                    dynamicApprovedCount = dynamicSaved_1.filter(function (item) { return item.ResponseValue === "true"; }).length;
                    dynamicRejectedCount = dynamicSaved_1.filter(function (item) { return item.ResponseValue === "false"; }).length;
                    dynamicTotalCount = allDynamic_1.length;
                    fastnerApprovedCount = fastenerSaved_1.filter(function (item) { return item.ResponseValue === "true"; }).length;
                    fastnerRejectedCount = fastenerSaved_1.filter(function (item) { return item.ResponseValue === "false"; }).length;
                    fastnerTotalCount = allFastner_1.length;
                    staticApprovedCount = staticSaved_1.filter(function (item) { return item.ResponseValue === "true"; }).length;
                    staticRejectedCount = staticSaved_1.filter(function (item) { return item.ResponseValue === "false"; }).length;
                    staticTotalCount = allStatic_1.length;
                    returnData = {
                        dynamicApprovedCount: dynamicApprovedCount,
                        dynamicRejectedCount: dynamicRejectedCount,
                        dynamicTotalCount: dynamicTotalCount,
                        fastnerApprovedCount: fastnerApprovedCount,
                        fastnerRejectedCount: fastnerRejectedCount,
                        fastnerTotalCount: fastnerTotalCount,
                        staticApprovedCount: staticApprovedCount,
                        staticRejectedCount: staticRejectedCount,
                        staticTotalCount: staticTotalCount
                    };
                    return [3 /*break*/, 6];
                case 5:
                    returnData = {
                        dynamicApprovedCount: 0,
                        dynamicRejectedCount: 0,
                        dynamicTotalCount: 0,
                        fastnerApprovedCount: 0,
                        fastnerRejectedCount: 0,
                        fastnerTotalCount: 0,
                        staticApprovedCount: 0,
                        staticRejectedCount: 0,
                        staticTotalCount: 0
                    };
                    _a.label = 6;
                case 6: return [2 /*return*/, returnData];
            }
        });
    }); };
    var getRoadTest = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        JobCardId: jobCardId !== null && jobCardId !== void 0 ? jobCardId : ""
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL + APISchema.Jobcard, "/RoadTest"),
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    if (response.payload.success && response.payload.data && response.payload.data.RoadTest && response.payload.data.RoadTest.length > 0) {
                        return [2 /*return*/, {
                                roadTestApprovedCount: 1,
                                roadTestRejectedCount: 0
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                roadTestApprovedCount: 0,
                                roadTestRejectedCount: 0
                            }];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getMasterTotalCount = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload, body, response, _response$payload2, _response$payload3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: jobCardId,
                        ProductId: productId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCard/FIMasterCount?JobCardId=").concat(jobCardId),
                            request: body
                        }))];
                case 1:
                    response = _a.sent();
                    if ((_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.value) !== null && _response$payload !== void 0 && _response$payload.success) {
                        return [2 /*return*/, response !== null && response !== void 0 && (_response$payload2 = response.payload) !== null && _response$payload2 !== void 0 && (_response$payload2 = _response$payload2.value) !== null && _response$payload2 !== void 0 && _response$payload2.data ? (_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.value) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.data : null];
                    }
                    else {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getAllChecklistSavedData = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var masterTotalCountResponse, JCDetailsMasterResponse, savedAdditionalJobs, totalAdditionalJobsCount, additionalJobsApprovedCount, additionalJobsRejectedCount, savedPmParts, totalPmPartsLength, pmPartsApprovedCount, pmPartsRejectedCount, savedStandardJobs, standardJobsTotalCount, StandardJobsApprovedCount, StandardJobsRejectedCount, savedCustomerComplaints, totalCustomerComplaintsLength, customerComplaintsApprovedCount, customerComplainteRejectCount, savedChecklistData, dynamicApprovedCount, dynamicRejectedCount, dynamicTotalCount, fastnerApprovedCount, fastnerRejectedCount, fastnerTotalCount, staticApprovedCount, staticRejectedCount, staticTotalCount, roadTestDetails, roadTestApprovedCount, allItemsSave, AllChecklistCount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(setState({
                        key: "FIChecklistItemChange",
                        value: InitialFIChecklistItemChange
                    }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getMasterTotalCount(productId)];
                case 2:
                    masterTotalCountResponse = _a.sent();
                    return [4 /*yield*/, getJCDetailFIResponse()];
                case 3:
                    JCDetailsMasterResponse = _a.sent();
                    return [4 /*yield*/, getSavedAdditionalJobsList(JCDetailsMasterResponse)];
                case 4:
                    savedAdditionalJobs = _a.sent();
                    totalAdditionalJobsCount = masterTotalCountResponse !== null && masterTotalCountResponse !== void 0 && masterTotalCountResponse.ADDITIONAL_JOBS ? masterTotalCountResponse === null || masterTotalCountResponse === void 0 ? void 0 : masterTotalCountResponse.ADDITIONAL_JOBS : 0;
                    additionalJobsApprovedCount = savedAdditionalJobs.filter(function (item) { return item.Value === "true"; }).length;
                    additionalJobsRejectedCount = savedAdditionalJobs.filter(function (item) { return item.Value === "false"; }).length;
                    return [4 /*yield*/, getSavedPmParts(JCDetailsMasterResponse)];
                case 5:
                    savedPmParts = _a.sent();
                    totalPmPartsLength = masterTotalCountResponse !== null && masterTotalCountResponse !== void 0 && masterTotalCountResponse.PERIODIC_MAINTENANCE ? masterTotalCountResponse === null || masterTotalCountResponse === void 0 ? void 0 : masterTotalCountResponse.PERIODIC_MAINTENANCE : 0;
                    pmPartsApprovedCount = savedPmParts.filter(function (item) { return item.Value === "true"; }).length;
                    pmPartsRejectedCount = savedPmParts.filter(function (item) { return item.Value === "false"; }).length;
                    return [4 /*yield*/, getSavedStandardJobs(JCDetailsMasterResponse)];
                case 6:
                    savedStandardJobs = _a.sent();
                    standardJobsTotalCount = masterTotalCountResponse !== null && masterTotalCountResponse !== void 0 && masterTotalCountResponse.STANDARD_JOBS ? masterTotalCountResponse === null || masterTotalCountResponse === void 0 ? void 0 : masterTotalCountResponse.STANDARD_JOBS : 0;
                    StandardJobsApprovedCount = savedStandardJobs.filter(function (item) { return item.Value === "true"; }).length;
                    StandardJobsRejectedCount = savedStandardJobs.filter(function (item) { return item.Value === "false"; }).length;
                    return [4 /*yield*/, getSavedComplaints()];
                case 7:
                    savedCustomerComplaints = _a.sent();
                    totalCustomerComplaintsLength = masterTotalCountResponse !== null && masterTotalCountResponse !== void 0 && masterTotalCountResponse.CustomerVoiceToJobItem ? masterTotalCountResponse === null || masterTotalCountResponse === void 0 ? void 0 : masterTotalCountResponse.CustomerVoiceToJobItem : 0;
                    customerComplaintsApprovedCount = savedCustomerComplaints.filter(function (item) { return item.Value === "true"; }).length;
                    customerComplainteRejectCount = savedCustomerComplaints.filter(function (item) { return item.Value === "false"; }).length;
                    return [4 /*yield*/, getSavedDynamicChecklist(productId)];
                case 8:
                    savedChecklistData = _a.sent();
                    dynamicApprovedCount = savedChecklistData.dynamicApprovedCount;
                    dynamicRejectedCount = savedChecklistData.dynamicRejectedCount;
                    dynamicTotalCount = savedChecklistData.dynamicTotalCount;
                    fastnerApprovedCount = savedChecklistData.fastnerApprovedCount;
                    fastnerRejectedCount = savedChecklistData.fastnerRejectedCount;
                    fastnerTotalCount = savedChecklistData.fastnerTotalCount;
                    staticApprovedCount = savedChecklistData.staticApprovedCount;
                    staticRejectedCount = savedChecklistData.staticRejectedCount;
                    staticTotalCount = savedChecklistData.staticTotalCount;
                    return [4 /*yield*/, getRoadTest()];
                case 9:
                    roadTestDetails = _a.sent();
                    roadTestApprovedCount = roadTestDetails.roadTestApprovedCount;
                    allItemsSave = {
                        customerComplaints: {
                            isItemRejected: false,
                            isSaveClick: customerComplainteRejectCount > 0 || customerComplaintsApprovedCount > 0 || savedCustomerComplaints.length === 0 ? true : false
                        },
                        periodicMaintanance: {
                            isItemRejected: false,
                            isSaveClick: pmPartsRejectedCount > 0 || pmPartsApprovedCount > 0 || savedAdditionalJobs.length === 0 ? true : false
                        },
                        standardJobs: {
                            isItemRejected: false,
                            isSaveClick: StandardJobsRejectedCount > 0 || StandardJobsApprovedCount > 0 || savedStandardJobs.length === 0 ? true : false
                        },
                        additionalJobs: {
                            isItemRejected: false,
                            isSaveClick: additionalJobsRejectedCount > 0 || additionalJobsApprovedCount > 0 || savedAdditionalJobs.length === 0 ? true : false
                        },
                        staticFIChecklist: {
                            isItemRejected: false,
                            isSaveClick: staticRejectedCount > 0 || staticApprovedCount > 0 || staticTotalCount == 0 ? true : false
                        },
                        dynamicFIChecklist: {
                            isItemRejected: false,
                            isSaveClick: dynamicRejectedCount > 0 || dynamicApprovedCount > 0 || dynamicTotalCount == 0 ? true : false
                        },
                        fastnerCheklist: {
                            isItemRejected: false,
                            isSaveClick: fastnerRejectedCount > 0 || fastnerApprovedCount > 0 || fastnerTotalCount == 0 ? true : false
                        },
                        roadTest: {
                            isItemRejected: false,
                            isSaveClick: roadTestApprovedCount > 0 ? true : false
                        }
                    };
                    AllChecklistCount = {
                        customerComplaints: {
                            approvedCount: customerComplaintsApprovedCount,
                            totalCount: totalCustomerComplaintsLength,
                            rejectedCount: customerComplainteRejectCount
                        },
                        periodicMaintanance: {
                            approvedCount: pmPartsApprovedCount,
                            totalCount: totalPmPartsLength,
                            rejectedCount: pmPartsRejectedCount
                        },
                        standardJobs: {
                            approvedCount: StandardJobsApprovedCount,
                            totalCount: standardJobsTotalCount,
                            rejectedCount: StandardJobsRejectedCount
                        },
                        additionalJobs: {
                            approvedCount: additionalJobsApprovedCount,
                            totalCount: totalAdditionalJobsCount,
                            rejectedCount: additionalJobsRejectedCount
                        },
                        staticFIChecklist: {
                            approvedCount: staticApprovedCount,
                            totalCount: staticTotalCount,
                            rejectedCount: staticRejectedCount
                        },
                        dynamicFIChecklist: {
                            approvedCount: dynamicApprovedCount,
                            totalCount: dynamicTotalCount,
                            rejectedCount: dynamicRejectedCount
                        },
                        fastnerCheklist: {
                            approvedCount: fastnerApprovedCount,
                            totalCount: fastnerTotalCount,
                            rejectedCount: fastnerRejectedCount
                        },
                        roadTest: {
                            approvedCount: roadTestApprovedCount,
                            totalCount: 0,
                            rejectedCount: 0
                        }
                    };
                    return [4 /*yield*/, dispatch(setState({
                            key: "FinalInspectionChecklistCount",
                            value: AllChecklistCount
                        }))];
                case 10:
                    _a.sent();
                    return [4 /*yield*/, dispatch(setState({
                            key: "FIChecklistItemChange",
                            value: allItemsSave
                        }))];
                case 11:
                    _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 12:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getFIChecklistCount = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var body, answersResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: jobCardId,
                        ChildId: productId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCard/ReworkItemCount"),
                            request: body
                        }))];
                case 1:
                    answersResponse = _a.sent();
                    if (answersResponse.payload.success) {
                        // setApprovedChecklitsCount(answersResponse.payload.count ?? 0)
                        // setTotalChecklistCount(answersResponse.payload.TotalCount ?? 0)
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getInitialData = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var data, updatedList_1, obj_1, newArray_1, finalModuleSectionArray_1, res, sortedArray;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_FINALINSPECTION);
                    if (!((data === null || data === void 0 ? void 0 : data.length) > 0)) return [3 /*break*/, 2];
                    updatedList_1 = [];
                    data.map(function (item) {
                        var newObj = Object.assign({}, item, item.Section);
                        delete newObj.Section;
                        updatedList_1.push(_objectSpread(_objectSpread({}, newObj), {}, {
                            isAccordianOpen: false
                        }));
                    });
                    obj_1 = {};
                    newArray_1 = [];
                    finalModuleSectionArray_1 = [];
                    res = updatedList_1.map(function (elem) {
                        var newSectionAttribute = elem.SectionAttributes;
                        var mergedObj = null;
                        var newAttribute = newSectionAttribute.map(function (el) {
                            if (el !== null && el !== void 0 && el.Key && !el.IsDeleted) {
                                obj_1[el.Key] = el.Value === ESectionAttributeValue.ON ? true : false;
                                obj_1[el.Key + "DefaultValue"] = el.DefaultValue === ESectionAttributeValue.ON ? true : false;
                                mergedObj = _objectSpread(_objectSpread({}, el), obj_1);
                            }
                        });
                        if (mergedObj) {
                            newArray_1.push(mergedObj);
                        }
                        obj_1 = {};
                        delete elem.SectionAttributes;
                        elem['SectionAttributes'] = [];
                        newArray_1.forEach(function (value) {
                            newSectionAttribute.forEach(function (value1) {
                                if (value.id == value1.id) {
                                    elem.SectionAttributes.push(value);
                                }
                            });
                        });
                        finalModuleSectionArray_1.push(elem);
                    });
                    sortedArray = finalModuleSectionArray_1 === null || finalModuleSectionArray_1 === void 0 ? void 0 : finalModuleSectionArray_1.sort(function (a, b) { return a.Sequence - b.Sequence; });
                    return [4 /*yield*/, dispatch(setUpdatedModuleSectionByChannel(sortedArray))];
                case 1:
                    _a.sent();
                    performAllButtonAction(sortedArray);
                    getDisabled();
                    getAllChecklistSavedData(productId);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getDisabled = function () {
        var disableValue = false;
        if (updatedModuleSectionByChannel.length > 0) {
            updatedModuleSectionByChannel.map(function (item) {
                switch 
                // case EFinalInspectorModuleSection.PeriodicMaintenance:
                //   if (item?.SectionAttributes[0]?.MANDATORY && item?.SectionAttributes[0]?.Count > getSavedTaskDetailsCount?.periodicMaintenanceCount) {
                //     disableValue = true
                //   }
                //   break;
                // case EFinalInspectorModuleSection.StandardJobs:
                //   if (item?.SectionAttributes[0]?.MANDATORY && item?.SectionAttributes[0]?.Count > getSavedTaskDetailsCount?.standardJobsCount) {
                //     disableValue = true
                //   }
                //   break;
                // case EFinalInspectorModuleSection.Precheck:
                //   if (item?.SectionAttributes[0]?.MANDATORY && item?.SectionAttributes[0]?.Count > getSavedTaskDetailsCount?.preCheckCount) {
                //     disableValue = true
                //   }
                //   break;
                // case EFinalInspectorModuleSection.AdditionalJobs:
                //   if (item?.SectionAttributes[0]?.MANDATORY && item?.SectionAttributes[0]?.Count > getSavedTaskDetailsCount?.additionalJobsCount) {
                //     disableValue = true
                //   }
                //   break;
                // default:
                //   disableValue = false
                //   break;
                (item.Key) {
                }
            });
        }
        else {
            disableValue = true;
        }
        dispatch(setTasksDetailsIsDisable(disableValue));
        //setGetDisableValue(disableValue)
        //return disableValue
    };
    var performAllButtonAction = function (finalModuleSectionArray) {
        try {
            if (finalModuleSectionArray.length > 0) {
                var count_1 = 0;
                finalModuleSectionArray.map(function (item) {
                    var _item$SectionAttribut, _item$SectionAttribut2;
                    if (item !== null && item !== void 0 && (_item$SectionAttribut = item.SectionAttributes[0]) !== null && _item$SectionAttribut !== void 0 && _item$SectionAttribut.MANDATORYDefaultValue || item !== null && item !== void 0 && (_item$SectionAttribut2 = item.SectionAttributes[0]) !== null && _item$SectionAttribut2 !== void 0 && _item$SectionAttribut2.OPTIONALDefaultValue) {
                        count_1 = count_1 + 1;
                    }
                });
                if ((finalModuleSectionArray === null || finalModuleSectionArray === void 0 ? void 0 : finalModuleSectionArray.length) === count_1) {
                    setAllSwitchEnabled(!allswitchEnabled);
                }
            }
        }
        catch (e) {
            console.error("Error-", e);
        }
    };
    var getFIObservation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _FIObservationResult$, _FIObservationResult$2, payload, FIObservationResult, _FIObservationResult$3, _FIObservationResult$4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!jobCardId) return [3 /*break*/, 2];
                    payload = {
                        JobCardId: jobCardId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getFIObservationData,
                            request: payload
                        }))];
                case 1:
                    FIObservationResult = _a.sent();
                    if (FIObservationResult !== null && FIObservationResult !== void 0 && (_FIObservationResult$ = FIObservationResult.payload) !== null && _FIObservationResult$ !== void 0 && _FIObservationResult$.data && FIObservationResult !== null && FIObservationResult !== void 0 && (_FIObservationResult$2 = FIObservationResult.payload) !== null && _FIObservationResult$2 !== void 0 && _FIObservationResult$2.success) {
                        setFIObservationDetails(FIObservationResult === null || FIObservationResult === void 0 || (_FIObservationResult$3 = FIObservationResult.payload) === null || _FIObservationResult$3 === void 0 ? void 0 : _FIObservationResult$3.data);
                        getDownloadImage(FIObservationResult === null || FIObservationResult === void 0 || (_FIObservationResult$4 = FIObservationResult.payload) === null || _FIObservationResult$4 === void 0 ? void 0 : _FIObservationResult$4.data.ImageAttachments);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var getDownloadImage = function (ImageAttachments) { return __awaiter(void 0, void 0, void 0, function () {
        var imageAttachementURLs, audioAttachementURLs, imageAttachmentsUrlWithMediaType1, downloadPromise, audioAttachmentsUrlWithMediaType2, downloadPromise1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    imageAttachementURLs = [];
                    audioAttachementURLs = [];
                    imageAttachmentsUrlWithMediaType1 = ImageAttachments.filter(function (item) { return item.MediaType === 1; });
                    downloadPromise = imageAttachmentsUrlWithMediaType1.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var base64, error_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, imageItem.id, getDownloadJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    imageAttachementURLs.push({
                                        blobUrl: base64,
                                        file: null,
                                        isAlreadyUploaded: true,
                                        AttachmentId: imageItem.AttachmentId,
                                        createdOn: imageItem.CreatedOn
                                    });
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_2 = _a.sent();
                                    console.error(error_2);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    audioAttachmentsUrlWithMediaType2 = ImageAttachments.filter(function (item) { return item.MediaType === 2; });
                    downloadPromise1 = audioAttachmentsUrlWithMediaType2.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var base64, error_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, imageItem.id, getDownloadJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    audioAttachementURLs.push({
                                        audioBlobUrl: base64,
                                        audioFile: null,
                                        AttachmentId: imageItem.AttachmentId
                                    });
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_3 = _a.sent();
                                    console.error(error_3);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, Promise.all(downloadPromise)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all(downloadPromise1)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 5:
                    setFIObservationImages(imageAttachementURLs);
                    setFIObservationAudios(audioAttachementURLs.length > 0 ? audioAttachementURLs[0] : null);
                    return [2 /*return*/];
            }
        });
    }); };
    var documentDetailsDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload2, _result$payload3, result, _result$payload4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dispatch(setState({
                            key: "documentDetailsGetById",
                            value: null
                        }))];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "documentDetailsGetById",
                            url: jobCardGetDetailAPI(jobCardId)
                        }))];
                case 3:
                    result = _a.sent();
                    if (!((_result$payload = result.payload) !== null && _result$payload !== void 0 && _result$payload.value && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && _result$payload2.value.success && (_result$payload3 = result.payload) !== null && _result$payload3 !== void 0 && (_result$payload3 = _result$payload3.value) !== null && _result$payload3 !== void 0 && _result$payload3.data)) return [3 /*break*/, 4];
                    // getFIChecklistCount(result.payload?.value?.data?.ProductId)
                    getInitialData((_result$payload4 = result.payload) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.value) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.data) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.ProductId);
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var onClickBackArrow = function () {
        if (isViewOnly) {
            navigate("/jobcard-details/".concat(jobCardId));
        }
        else {
            setOpenPopup(true);
        }
    };
    var handleAllSwitchButtonState = function () {
        setAllSwitchEnabled(!allswitchEnabled);
    };
    var getAdditionalJobApiCall = function () {
        setAddiotionalJobApiCall(true);
    };
    var onClickLeaveBtn = function () {
        setOpenPopup(false);
        navigate("/jobcard-details/".concat(jobCardId));
    };
    var goToHomePage = function () {
        navigate('/appointment');
    };
    var onClickStayBtn = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setOpenPopup(false);
            return [2 /*return*/];
        });
    }); };
    var handleClickFinishInspection = function () { return __awaiter(void 0, void 0, void 0, function () {
        var finishInspectionResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(updateAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCard/").concat(jobCardId, "/InspectionCompletedJobCard")
                        }))];
                case 1:
                    finishInspectionResponse = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (finishInspectionResponse.payload.success) {
                        // navigate('/finalInspection')
                        setFinishInspectionPopup(true);
                        // buttonClickSpan.end();
                        // pageLoadSpan.end();
                        // transaction.end();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCancelPopup = function () {
        navigate('/appointment');
    };
    var handleComplaintData = function (data) {
        saveFIObservation(data);
    };
    var uploadAttachmentUsingId = function (PreJobCardDocumentAttachmentId, data) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, UploadImage("".concat(Config.baseURL, "resource/JobCardDocumentAttachment/").concat(PreJobCardDocumentAttachmentId), data, "BlankSystemName", dispatch)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
                case 2:
                    error_4 = _a.sent();
                    return [2 /*return*/, ""];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var saveFIObservation = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _data$images, _FIObservationResult$5, updatedImageList_1, ImageAttachmentsBody_1, imagesToBeUpload, audioFiles, request, ResponseData, PreJobCardDocumentAttachmentIds, imageAttachmentsWithMediaType1_1, uploadPromises, audioAttachmentsWithMediaType2_1, uploadPromises1, imagePayload_1, requestBody, FIObservationResult, _audioAttachmentsWith, imageAttachmentsWithMediaType1, audioAttachmentsWithMediaType2, uniqueImagesArray, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 7, , 9]);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    updatedImageList_1 = [];
                    ImageAttachmentsBody_1 = [];
                    imagesToBeUpload = [];
                    if (data.images && ((_data$images = data.images) === null || _data$images === void 0 ? void 0 : _data$images.length) > 0) {
                        imagesToBeUpload = data.images.filter(function (item) { return !item.isAlreadyUploaded; });
                        imagesToBeUpload.map(function (imageItem) {
                            if (!imageItem.isAlreadyUploaded) {
                                ImageAttachmentsBody_1.push({
                                    SystemName: "AssigntoFinalInspector",
                                    MediaType: 1
                                });
                            }
                        });
                    }
                    audioFiles = [];
                    if (data !== null && data !== void 0 && data.audio) {
                        audioFiles = Array.isArray(data.audio) ? data.audio : [data.audio];
                    }
                    if (data !== null && data !== void 0 && data.audio) {
                        audioFiles.map(function (audioItem) {
                            if (audioItem.audioFile)
                                ImageAttachmentsBody_1.push({
                                    SystemName: "AssigntoFinalInspector",
                                    MediaType: 2
                                });
                        });
                    }
                    if (!(ImageAttachmentsBody_1.length > 0)) return [3 /*break*/, 5];
                    request = {
                        ParentId: jobCardId,
                        ImageAttachments: ImageAttachmentsBody_1
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: '',
                            url: jobCardAttachmentCreateUrl,
                            request: request
                        }))];
                case 2:
                    ResponseData = _a.sent();
                    PreJobCardDocumentAttachmentIds = [];
                    if (ResponseData.payload.success && ResponseData.payload.data) {
                        PreJobCardDocumentAttachmentIds = ResponseData.payload.data;
                    }
                    imageAttachmentsWithMediaType1_1 = PreJobCardDocumentAttachmentIds.filter(function (item) { return item.MediaType === 1; });
                    uploadPromises = imagesToBeUpload.map(function (imageItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var formData, matchingAttachment, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!!imageItem.isAlreadyUploaded) return [3 /*break*/, 3];
                                    formData = new FormData();
                                    formData.append('data', imageItem.file);
                                    matchingAttachment = imageAttachmentsWithMediaType1_1[index];
                                    if (!matchingAttachment) return [3 /*break*/, 2];
                                    return [4 /*yield*/, uploadAttachmentUsingId(matchingAttachment.JobCardDocumentAttachmentId, formData)];
                                case 1:
                                    result = _a.sent();
                                    if (result.success) {
                                        updatedImageList_1.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                            AttachmentId: result.attachmentId,
                                            MediaType: 1,
                                            createdOn: matchingAttachment === null || matchingAttachment === void 0 ? void 0 : matchingAttachment.CreatedOn
                                        }));
                                    }
                                    else {
                                        updatedImageList_1.push(_objectSpread(_objectSpread({}, imageItem), {}, {
                                            MediaType: 1
                                        }));
                                    }
                                    return [3 /*break*/, 3];
                                case 2:
                                    // Handle the case where there is no matching attachment with MediaType === 1
                                    console.error("No matching attachment found with MediaType === 1");
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises)];
                case 3:
                    _a.sent();
                    audioAttachmentsWithMediaType2_1 = PreJobCardDocumentAttachmentIds.filter(function (item) { return item.MediaType === 2; });
                    uploadPromises1 = audioFiles.map(function (audioItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var formData, matchingAttachment, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    formData = new FormData();
                                    formData.append('data', audioItem.audioFile);
                                    matchingAttachment = audioAttachmentsWithMediaType2_1[index];
                                    if (!matchingAttachment) return [3 /*break*/, 2];
                                    return [4 /*yield*/, uploadAttachmentUsingId(matchingAttachment.JobCardDocumentAttachmentId, formData)];
                                case 1:
                                    result = _a.sent();
                                    if (result !== null && result !== void 0 && result.success) {
                                        updatedImageList_1.push(_objectSpread(_objectSpread({}, audioItem), {}, {
                                            AttachmentId: result.attachmentId,
                                            MediaType: 2
                                        }));
                                    }
                                    else {
                                        updatedImageList_1.push(_objectSpread(_objectSpread({}, audioItem), {}, {
                                            MediaType: 2
                                        }));
                                    }
                                    return [3 /*break*/, 3];
                                case 2:
                                    // Handle the case where there is no matching attachment with MediaType === 2
                                    console.error("No matching attachment found with MediaType === 2");
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises1)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    imagePayload_1 = [];
                    if (updatedImageList_1) {
                        updatedImageList_1.map(function (imageItem) {
                            if (imageItem.AttachmentId) {
                                imagePayload_1.push({
                                    "AttachmentId": imageItem.AttachmentId,
                                    "MediaType": imageItem.MediaType,
                                    "SystemName": "AssigntoFinalInspector"
                                });
                            }
                        });
                    }
                    requestBody = {
                        JobCardId: jobCardId,
                        FinalInspectorId: FIObservationDetails === null || FIObservationDetails === void 0 ? void 0 : FIObservationDetails.FinalInspectorId,
                        ImageAttachments: imagePayload_1
                    };
                    if (data.discription) {
                        requestBody.Observation = data.discription;
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: saveFIObservationDataUrl,
                            request: requestBody
                        }))];
                case 6:
                    FIObservationResult = _a.sent();
                    if (FIObservationResult !== null && FIObservationResult !== void 0 && (_FIObservationResult$5 = FIObservationResult.payload) !== null && _FIObservationResult$5 !== void 0 && (_FIObservationResult$5 = _FIObservationResult$5.value) !== null && _FIObservationResult$5 !== void 0 && _FIObservationResult$5.success) {
                        if (updatedImageList_1.length > 0) {
                            imageAttachmentsWithMediaType1 = updatedImageList_1.filter(function (item) { return item.MediaType === 1; });
                            audioAttachmentsWithMediaType2 = updatedImageList_1.filter(function (item) { return item.MediaType === 2; });
                            imageAttachmentsWithMediaType1 = __spreadArray(__spreadArray([], imageAttachmentsWithMediaType1, true), data.images, true);
                            imageAttachmentsWithMediaType1 = imageAttachmentsWithMediaType1.filter(function (item) { return item.AttachmentId; });
                            imageAttachmentsWithMediaType1 = imageAttachmentsWithMediaType1.map(function (item) { return [item["AttachmentId"], item]; });
                            uniqueImagesArray = Array.from(new Map(imageAttachmentsWithMediaType1).values());
                            uniqueImagesArray = uniqueImagesArray.map(function (item) {
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    isAlreadyUploaded: true
                                });
                            });
                            audioAttachmentsWithMediaType2 = audioAttachmentsWithMediaType2.map(function (item) {
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    isAlreadyUploaded: true
                                });
                            });
                            setFIObservationImages(uniqueImagesArray);
                            setFIObservationAudios(((_audioAttachmentsWith = audioAttachmentsWithMediaType2) === null || _audioAttachmentsWith === void 0 ? void 0 : _audioAttachmentsWith.length) > 0 ? audioAttachmentsWithMediaType2[0] : null);
                            setFIObservationDetails(_objectSpread(_objectSpread({}, FIObservationDetails), {}, {
                                Observation: finalInspectorObservationDetails !== null && finalInspectorObservationDetails !== void 0 && finalInspectorObservationDetails.discription ? finalInspectorObservationDetails === null || finalInspectorObservationDetails === void 0 ? void 0 : finalInspectorObservationDetails.discription : FIObservationDetails.Observation
                            }));
                        }
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("FI Observations saved successfully"),
                            type: "success"
                        }));
                    }
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [3 /*break*/, 9];
                case 7:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 8:
                    _a.sent();
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var checkAllApproved = function () {
        var validateMessage = "";
        var allApproved = [];
        updatedModuleSectionByChannel.map(function (item) {
            validateMessage = "Please save ".concat(item === null || item === void 0 ? void 0 : item.DisplayName);
            switch (item.Key) {
                case EFinalInspectorModuleSection.RoadTest:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut3;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut3 = item.SectionAttributes[0]) !== null && _item$SectionAttribut3 !== void 0 && _item$SectionAttribut3.MANDATORY) {
                            if (FinalInspectionChecklistCount.roadTest.rejectedCount === 0) {
                                // dispatch(showNotification({ isOpen: true, message: validateMessage, type: "error", }));
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                        else {
                            if (FinalInspectionChecklistCount.roadTest.rejectedCount === 0) {
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                    }
                    else {
                        allApproved.push("true");
                    }
                    break;
                case EFinalInspectorModuleSection.CustomerComplaints:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut4;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut4 = item.SectionAttributes[0]) !== null && _item$SectionAttribut4 !== void 0 && _item$SectionAttribut4.MANDATORY) {
                            if (FinalInspectionChecklistCount.customerComplaints.rejectedCount === 0) {
                                // dispatch(showNotification({ isOpen: true, message: validateMessage, type: "error", }));
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                        else {
                            if (FinalInspectionChecklistCount.customerComplaints.rejectedCount === 0) {
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                    }
                    else {
                        allApproved.push("true");
                    }
                    break;
                case EFinalInspectorModuleSection.PeriodicMaintenance:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut5;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut5 = item.SectionAttributes[0]) !== null && _item$SectionAttribut5 !== void 0 && _item$SectionAttribut5.MANDATORY) {
                            if (FinalInspectionChecklistCount.periodicMaintanance.rejectedCount === 0) {
                                // dispatch(showNotification({ isOpen: true, message: validateMessage, type: "error", }));
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                        else {
                            if (FinalInspectionChecklistCount.periodicMaintanance.rejectedCount === 0) {
                                // dispatch(showNotification({ isOpen: true, message: validateMessage, type: "error", }));
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                    }
                    else {
                        allApproved.push("true");
                    }
                    break;
                case EFinalInspectorModuleSection.StandardJobs:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut6;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut6 = item.SectionAttributes[0]) !== null && _item$SectionAttribut6 !== void 0 && _item$SectionAttribut6.MANDATORY) {
                            if (FinalInspectionChecklistCount.standardJobs.rejectedCount === 0) {
                                // dispatch(showNotification({ isOpen: true, message: validateMessage, type: "error", }));
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                        else {
                            if (FinalInspectionChecklistCount.standardJobs.rejectedCount === 0) {
                                // dispatch(showNotification({ isOpen: true, message: validateMessage, type: "error", }));
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                    }
                    else {
                        allApproved.push("true");
                    }
                    break;
                case EFinalInspectorModuleSection.AdditionalJobs:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut7;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut7 = item.SectionAttributes[0]) !== null && _item$SectionAttribut7 !== void 0 && _item$SectionAttribut7.MANDATORY) {
                            if (FinalInspectionChecklistCount.additionalJobs.rejectedCount === 0) {
                                // dispatch(showNotification({ isOpen: true, message: validateMessage, type: "error", }));
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                        else {
                            if (FinalInspectionChecklistCount.additionalJobs.rejectedCount === 0) {
                                // dispatch(showNotification({ isOpen: true, message: validateMessage, type: "error", }));
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                    }
                    else {
                        allApproved.push("true");
                    }
                    break;
                case EFinalInspectorModuleSection.StaticFIChecklist:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut8;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut8 = item.SectionAttributes[0]) !== null && _item$SectionAttribut8 !== void 0 && _item$SectionAttribut8.MANDATORY) {
                            if (FinalInspectionChecklistCount.staticFIChecklist.rejectedCount === 0) {
                                // dispatch(showNotification({ isOpen: true, message: validateMessage, type: "error", }));
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                        else {
                            if (FinalInspectionChecklistCount.staticFIChecklist.rejectedCount === 0) {
                                // dispatch(showNotification({ isOpen: true, message: validateMessage, type: "error", }));
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                    }
                    else {
                        allApproved.push("true");
                    }
                    break;
                case EFinalInspectorModuleSection.DynamicChecklist:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut9;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut9 = item.SectionAttributes[0]) !== null && _item$SectionAttribut9 !== void 0 && _item$SectionAttribut9.MANDATORY) {
                            if (FinalInspectionChecklistCount.dynamicFIChecklist.rejectedCount === 0) {
                                // dispatch(showNotification({ isOpen: true, message: validateMessage, type: "error", }));
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                        else {
                            if (FinalInspectionChecklistCount.dynamicFIChecklist.rejectedCount === 0) {
                                // dispatch(showNotification({ isOpen: true, message: validateMessage, type: "error", }));
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                    }
                    else {
                        allApproved.push("true");
                    }
                    break;
                case EFinalInspectorModuleSection.FastnerChecklist:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut10;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut10 = item.SectionAttributes[0]) !== null && _item$SectionAttribut10 !== void 0 && _item$SectionAttribut10.MANDATORY) {
                            if (FinalInspectionChecklistCount.fastnerCheklist.rejectedCount === 0) {
                                // dispatch(showNotification({ isOpen: true, message: validateMessage, type: "error", }));
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                        else {
                            if (FinalInspectionChecklistCount.fastnerCheklist.rejectedCount === 0) {
                                // dispatch(showNotification({ isOpen: true, message: validateMessage, type: "error", }));
                                allApproved.push("true");
                            }
                            else {
                                allApproved.push("false");
                            }
                        }
                    }
                    else {
                        allApproved.push("true");
                    }
                    break;
                default:
                    allApproved.push("true");
                    break;
            }
        });
        var all_true = allApproved.every(function (item) { return item === "true"; });
        return all_true;
    };
    var checkAllMadatorySaved = function () {
        var validateMessage = "";
        var validAll = [];
        updatedModuleSectionByChannel.map(function (item) {
            validateMessage = "Please save ".concat(item === null || item === void 0 ? void 0 : item.DisplayName);
            switch (item.Key) {
                case EFinalInspectorModuleSection.RoadTest:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut11;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut11 = item.SectionAttributes[0]) !== null && _item$SectionAttribut11 !== void 0 && _item$SectionAttribut11.MANDATORY) {
                            if (FIChecklistItemChange.roadTest.isSaveClick) {
                                validAll.push("true");
                            }
                            else {
                                validAll.push("false");
                            }
                        }
                        else {
                            validAll.push("true");
                        }
                    }
                    else {
                        validAll.push("true");
                    }
                    break;
                case EFinalInspectorModuleSection.CustomerComplaints:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut12;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut12 = item.SectionAttributes[0]) !== null && _item$SectionAttribut12 !== void 0 && _item$SectionAttribut12.MANDATORY) {
                            if (FIChecklistItemChange.customerComplaints.isSaveClick) {
                                validAll.push("true");
                            }
                            else {
                                validAll.push("false");
                            }
                        }
                        else {
                            validAll.push("true");
                        }
                    }
                    else {
                        validAll.push("true");
                    }
                    break;
                case EFinalInspectorModuleSection.PeriodicMaintenance:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut13;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut13 = item.SectionAttributes[0]) !== null && _item$SectionAttribut13 !== void 0 && _item$SectionAttribut13.MANDATORY) {
                            if (FIChecklistItemChange.periodicMaintanance.isSaveClick) {
                                validAll.push("true");
                            }
                            else {
                                validAll.push("false");
                            }
                        }
                        else {
                            validAll.push("true");
                        }
                    }
                    else {
                        validAll.push("true");
                    }
                    break;
                case EFinalInspectorModuleSection.StandardJobs:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut14;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut14 = item.SectionAttributes[0]) !== null && _item$SectionAttribut14 !== void 0 && _item$SectionAttribut14.MANDATORY) {
                            if (FIChecklistItemChange.standardJobs.isSaveClick) {
                                validAll.push("true");
                            }
                            else {
                                validAll.push("false");
                            }
                        }
                        else {
                            validAll.push("true");
                        }
                    }
                    else {
                        validAll.push("true");
                    }
                    break;
                case EFinalInspectorModuleSection.AdditionalJobs:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut15;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut15 = item.SectionAttributes[0]) !== null && _item$SectionAttribut15 !== void 0 && _item$SectionAttribut15.MANDATORY) {
                            if (FIChecklistItemChange.additionalJobs.isSaveClick) {
                                validAll.push("true");
                            }
                            else {
                                validAll.push("false");
                            }
                        }
                        else {
                            validAll.push("true");
                        }
                    }
                    else {
                        validAll.push("true");
                    }
                    break;
                case EFinalInspectorModuleSection.StaticFIChecklist:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut16;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut16 = item.SectionAttributes[0]) !== null && _item$SectionAttribut16 !== void 0 && _item$SectionAttribut16.MANDATORY) {
                            if (FIChecklistItemChange.staticFIChecklist.isSaveClick) {
                                validAll.push("true");
                            }
                            else {
                                validAll.push("false");
                            }
                        }
                        else {
                            validAll.push("true");
                        }
                    }
                    else {
                        validAll.push("true");
                    }
                    break;
                case EFinalInspectorModuleSection.DynamicChecklist:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut17;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut17 = item.SectionAttributes[0]) !== null && _item$SectionAttribut17 !== void 0 && _item$SectionAttribut17.MANDATORY) {
                            if (FIChecklistItemChange.dynamicFIChecklist.isSaveClick) {
                                validAll.push("true");
                            }
                            else {
                                validAll.push("false");
                            }
                        }
                        else {
                            validAll.push("true");
                        }
                    }
                    else {
                        validAll.push("true");
                    }
                    break;
                case EFinalInspectorModuleSection.FastnerChecklist:
                    if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0) {
                        var _item$SectionAttribut18;
                        if (item !== null && item !== void 0 && (_item$SectionAttribut18 = item.SectionAttributes[0]) !== null && _item$SectionAttribut18 !== void 0 && _item$SectionAttribut18.MANDATORY) {
                            if (FIChecklistItemChange.fastnerCheklist.isSaveClick) {
                                validAll.push("true");
                            }
                            else {
                                validAll.push("false");
                            }
                        }
                        else {
                            validAll.push("true");
                        }
                    }
                    else {
                        validAll.push("true");
                    }
                    break;
                default:
                    validAll.push("true");
                    break;
            }
        });
        var all_true = validAll.every(function (item) { return item === "true"; });
        return all_true;
    };
    var getFIButtonDetails = function () {
        var isAllItemsApproved = false;
        isAllItemsApproved = checkAllApproved();
        var isAllItemsSaveClick = checkAllMadatorySaved();
        if (!isAllItemsSaveClick) {
            if (isAllItemsApproved) {
                return {
                    buttonName: FITaskDetailsButtonVariant.FinishInspection,
                    isDisabled: true
                };
            }
            else {
                return {
                    buttonName: FITaskDetailsButtonVariant.SendBack,
                    isDisabled: true
                };
            }
        }
        if (isAllItemsSaveClick) {
            if (isAllItemsApproved) {
                return {
                    buttonName: FITaskDetailsButtonVariant.FinishInspection,
                    isDisabled: false
                };
            }
            else {
                return {
                    buttonName: FITaskDetailsButtonVariant.SendBack,
                    isDisabled: false
                };
            }
        }
    };
    var handleClickButton = function (buttonVariant) {
        if (buttonVariant === FITaskDetailsButtonVariant.FinishInspection) {
            handleClickFinishInspection();
        }
        if (buttonVariant === FITaskDetailsButtonVariant.SendBack) {
            setOpenSendBackPopup(true);
        }
    };
    var sendJobCardForRework = function () { return __awaiter(void 0, void 0, void 0, function () {
        var reworkInspectionResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dispatch(updateAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCard/").concat(jobCardId, "/ReworkJobCard")
                        }))];
                case 2:
                    reworkInspectionResponse = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    setOpenSendBackPopup(false);
                    if (reworkInspectionResponse.payload.success) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Job card sent back for rework",
                            type: "success"
                        }));
                        navigate('/finalInspection');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAccordianClick = function (value, key) {
        var updatedList = updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.map(function (item) { return item.Key == key ? _objectSpread(_objectSpread({}, item), {}, {
            isAccordianOpen: value
        }) : _objectSpread(_objectSpread({}, item), {}, {
            isAccordianOpen: false
        }); });
        dispatch(setUpdatedModuleSectionByChannel(updatedList));
    };
    var listVariants = [{
            id: 1,
            Name: 'General',
            DisplayName: 'General'
        }, {
            id: 2,
            Name: 'TaskDetails',
            DisplayName: 'Task Details'
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(HeaderDetails, {
        headerTitle: 'Final Inspection',
        status: (_documentDetailsGetBy4 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy5 = documentDetailsGetById.data) === null || _documentDetailsGetBy5 === void 0 ? void 0 : _documentDetailsGetBy5.StatusName) !== null && _documentDetailsGetBy4 !== void 0 ? _documentDetailsGetBy4 : "",
        docDate: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy6 = documentDetailsGetById.data) === null || _documentDetailsGetBy6 === void 0 ? void 0 : _documentDetailsGetBy6.CreatedOn,
        docNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy7 = documentDetailsGetById.data) === null || _documentDetailsGetBy7 === void 0 ? void 0 : _documentDetailsGetBy7.Code,
        sourceDocumentNo: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy8 = documentDetailsGetById.data) !== null && _documentDetailsGetBy8 !== void 0 && _documentDetailsGetBy8.SourceDocumentNo ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy9 = documentDetailsGetById.data) === null || _documentDetailsGetBy9 === void 0 ? void 0 : _documentDetailsGetBy9.SourceDocumentNo : "",
        onHandleClick: onClickBackArrow,
        onMoreIconClick: function (event) { },
        isFromAppointment: false,
        parentComponent: EParentModuleName.Jobcard,
        statusKey: ''
        // onClickJobCardStatusProgress={onClickStatusStepperIcon}
    }), /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        paddingX: 2,
        lg: 12,
        xl: 12,
        p: 2
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            border: "1px solid ".concat(systemColor.grey),
            marginRight: '-15px',
            marginLeft: '-15px'
        }
    }))), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: systemColor.backgroundColor
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 8,
        md: 12,
        sm: 12,
        xs: 12
    }, documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data ? /*#__PURE__*/ React.createElement(React.Fragment, null, Module === isModuleConfig.Product && /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginRight: 3
        }
    }, /*#__PURE__*/ React.createElement(FormControlLabel, {
        value: "start",
        control: /*#__PURE__*/ React.createElement(IOSSwitch, {
            color: "primary",
            sx: {
                m: 1,
                mr: 4
            }
        }),
        label: t("Perform all"),
        labelPlacement: "start",
        onChange: handleAllSwitchButtonState
    })), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        paddingBottom: IS_DESKTOP ? 12 : 0
    }, updatedModuleSectionByChannel && updatedModuleSectionByChannel.length > 0 ? updatedModuleSectionByChannel.length > 0 ? updatedModuleSectionByChannel.map(function (item) { return (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.RoadTest ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 16px 8px 16px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            handleClick: function () { return setRoadTestApiCall(true); },
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.RoadTest); }
        }, /*#__PURE__*/ React.createElement(RoadTestComponent, {
            parentModuleName: EParentModuleName.finalInspector,
            parentModuleDocumentId: jobCardId !== null && jobCardId !== void 0 ? jobCardId : "",
            callApIStatus: roadTestApiCall,
            getCustomerComplaintListUrl: "",
            saveTranslateToJobItemUrl: "",
            apiRequestParam: APISchema.Jobcard,
            apiRequestPayload: {
                JobCardId: jobCardId !== null && jobCardId !== void 0 ? jobCardId : ""
            },
            isSaveButton: false,
            SystemName: '',
            isDisabled: isViewOnly
        }))) : null;
    }) : (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.CustomerComplaints ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 16px 8px 16px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            handleClick: function () { return setCustomerComplaintApiCall(true); },
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.CustomerComplaints); },
            declinejobCountVisible: FinalInspectionChecklistCount.customerComplaints.rejectedCount > 0,
            declineJobLength: FinalInspectionChecklistCount.customerComplaints.rejectedCount,
            highlightRejected: FinalInspectionChecklistCount.customerComplaints.rejectedCount > 0,
            highlightAccepted: FinalInspectionChecklistCount.customerComplaints.approvedCount > 0 && FinalInspectionChecklistCount.customerComplaints.rejectedCount === 0,
            countVisible: true,
            listLength: FinalInspectionChecklistCount.customerComplaints.totalCount
        }, /*#__PURE__*/ React.createElement(FinalInspectorCustomerComplaint, {
            callApIStatus: customerComplaintApiCall,
            isViewOnly: isViewOnly,
            jobCardId: jobCardId !== null && jobCardId !== void 0 ? jobCardId : "",
            showOnlyRejectedItems: false
        }))) : null;
    }) : (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.PeriodicMaintenance ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 16px 8px 16px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            handleClick: function () { return setPeriodicMaintainanceApiCall(true); },
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.PeriodicMaintenance); },
            declinejobCountVisible: FinalInspectionChecklistCount.periodicMaintanance.rejectedCount > 0,
            declineJobLength: FinalInspectionChecklistCount.periodicMaintanance.rejectedCount,
            highlightRejected: FinalInspectionChecklistCount.periodicMaintanance.rejectedCount > 0,
            highlightAccepted: FinalInspectionChecklistCount.periodicMaintanance.approvedCount > 0 && FinalInspectionChecklistCount.periodicMaintanance.rejectedCount === 0,
            countVisible: true,
            listLength: FinalInspectionChecklistCount.periodicMaintanance.totalCount
        }, /*#__PURE__*/ React.createElement(FinalInspectorAdditionalJobs, {
            jobCardId: jobCardId !== null && jobCardId !== void 0 ? jobCardId : "",
            isViewOnly: isViewOnly,
            paramKey: EFIJobCardDetailKeys.PERIODIC_MAINTENANCE,
            callApIStatus: periodicMaintainanceApiCall,
            parentComponent: EFIChecklistParent.PeriodicMaintenance,
            showOnlyRejectedItems: false
        }))) : null;
    }) : (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.StandardJobs ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 16px 8px 16px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            handleClick: function () { return setStandardJobApiCall(true); },
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.StandardJobs); },
            declinejobCountVisible: FinalInspectionChecklistCount.standardJobs.rejectedCount > 0,
            declineJobLength: FinalInspectionChecklistCount.standardJobs.rejectedCount,
            highlightRejected: FinalInspectionChecklistCount.standardJobs.rejectedCount > 0,
            highlightAccepted: FinalInspectionChecklistCount.standardJobs.approvedCount > 0 && FinalInspectionChecklistCount.standardJobs.rejectedCount === 0,
            countVisible: true,
            listLength: FinalInspectionChecklistCount.standardJobs.totalCount
        }, /*#__PURE__*/ React.createElement(FinalInspectorAdditionalJobs, {
            jobCardId: jobCardId !== null && jobCardId !== void 0 ? jobCardId : "",
            isViewOnly: isViewOnly,
            paramKey: EFIJobCardDetailKeys.STANDARD_JOBS,
            callApIStatus: standardJobApiCall,
            parentComponent: EFIChecklistParent.StandaredJobs,
            showOnlyRejectedItems: false
        }))) : null;
    }) : (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.AdditionalJobs ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 16px 8px 16px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            handleClick: function () { return getAdditionalJobApiCall(); },
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.AdditionalJobs); },
            declinejobCountVisible: FinalInspectionChecklistCount.additionalJobs.rejectedCount > 0,
            declineJobLength: FinalInspectionChecklistCount.additionalJobs.rejectedCount,
            highlightRejected: FinalInspectionChecklistCount.additionalJobs.rejectedCount > 0,
            highlightAccepted: FinalInspectionChecklistCount.additionalJobs.approvedCount > 0 && FinalInspectionChecklistCount.additionalJobs.rejectedCount === 0,
            countVisible: true,
            listLength: FinalInspectionChecklistCount.additionalJobs.totalCount
        }, /*#__PURE__*/ React.createElement(FinalInspectorAdditionalJobs, {
            jobCardId: jobCardId !== null && jobCardId !== void 0 ? jobCardId : "",
            isViewOnly: isViewOnly,
            paramKey: EFIJobCardDetailKeys.ADDITIONAL_JOBS,
            callApIStatus: addiotionalJobApiCall,
            parentComponent: EFIChecklistParent.AdditionalJobs,
            showOnlyRejectedItems: false
        }))) : null;
    }) : (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.StaticFIChecklist ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 16px 8px 16px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            handleClick: function () { return setStaticFIChecklistApiCall(true); },
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.StaticFIChecklist); },
            declinejobCountVisible: FinalInspectionChecklistCount.staticFIChecklist.rejectedCount > 0,
            declineJobLength: FinalInspectionChecklistCount.staticFIChecklist.rejectedCount,
            highlightRejected: FinalInspectionChecklistCount.staticFIChecklist.rejectedCount > 0,
            highlightAccepted: FinalInspectionChecklistCount.staticFIChecklist.approvedCount > 0 && FinalInspectionChecklistCount.staticFIChecklist.rejectedCount === 0,
            countVisible: true,
            listLength: FinalInspectionChecklistCount.staticFIChecklist.totalCount
        }, /*#__PURE__*/ React.createElement(FinalInspectorDynamicChecklist, {
            isViewOnly: isViewOnly,
            callApIStatus: staticFIChecklistApiCall,
            dynamicFIChecklistMaster: staticFIChecklist,
            paramKey: EFIChecklistKeys.StaticChecklist,
            parentComponent: EFIChecklistParent.StaticChecklist,
            jobCardId: jobCardId !== null && jobCardId !== void 0 ? jobCardId : "",
            showOnlyRejectedItems: false
        }))) : null;
    }) : (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.DynamicChecklist ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 16px 8px 16px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            handleClick: function () { return setDynamicChecklistApiCall(true); },
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.DynamicChecklist); },
            declinejobCountVisible: FinalInspectionChecklistCount.dynamicFIChecklist.rejectedCount > 0,
            declineJobLength: FinalInspectionChecklistCount.dynamicFIChecklist.rejectedCount,
            highlightRejected: FinalInspectionChecklistCount.dynamicFIChecklist.rejectedCount > 0,
            highlightAccepted: FinalInspectionChecklistCount.dynamicFIChecklist.approvedCount > 0 && FinalInspectionChecklistCount.dynamicFIChecklist.rejectedCount === 0,
            countVisible: true,
            listLength: FinalInspectionChecklistCount.dynamicFIChecklist.totalCount
        }, /*#__PURE__*/ React.createElement(FinalInspectorDynamicChecklist, {
            isViewOnly: isViewOnly,
            dynamicFIChecklistMaster: dynamicFIChecklist,
            callApIStatus: dynamicChecklistApiCall,
            paramKey: EFIChecklistKeys.DynamicChecklist,
            parentComponent: EFIChecklistParent.DynamicChecklist,
            jobCardId: jobCardId !== null && jobCardId !== void 0 ? jobCardId : "",
            showOnlyRejectedItems: false
        }))) : null;
    }) : (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.FastnerChecklist ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 16px 8px 16px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            handleClick: function () { return setFastnerChecklistApiCall(true); },
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.FastnerChecklist); },
            declinejobCountVisible: FinalInspectionChecklistCount.fastnerCheklist.rejectedCount > 0,
            declineJobLength: FinalInspectionChecklistCount.fastnerCheklist.rejectedCount,
            highlightRejected: FinalInspectionChecklistCount.fastnerCheklist.rejectedCount > 0,
            highlightAccepted: FinalInspectionChecklistCount.fastnerCheklist.approvedCount > 0 && FinalInspectionChecklistCount.fastnerCheklist.rejectedCount === 0,
            countVisible: true,
            listLength: FinalInspectionChecklistCount.fastnerCheklist.totalCount
        }, /*#__PURE__*/ React.createElement(FinalInspectorDynamicChecklist, {
            isViewOnly: isViewOnly,
            dynamicFIChecklistMaster: fastenerChecklist,
            callApIStatus: fastnerChecklistApiCall,
            paramKey: EFIChecklistKeys.FastnerChecklist,
            parentComponent: EFIChecklistParent.FastnerChecklist,
            jobCardId: jobCardId !== null && jobCardId !== void 0 ? jobCardId : "",
            showOnlyRejectedItems: false
        }))) : null;
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null); }) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(NoRowsOverlay, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, skeletonArray.map(function () { /*#__PURE__*/ return React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            width: '100vw',
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)); }))))) : /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        sx: {
            paddingTop: Module === isModuleConfig.Bajaj ? "0px" : "42px"
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)))), IS_DESKTOP && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 0.1,
        paddingY: '10px'
    }, /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            height: '100%'
        },
        orientation: "vertical"
    })), (documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 3.8,
        md: 12,
        sm: 12,
        xs: 12,
        padding: "16px 16px 8px 16px",
        paddingBottom: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h2"
    }, t("FI_OBSERVATION")), /*#__PURE__*/ React.createElement(FinalInspectorObservation, {
        isDisabled: isViewOnly,
        comments: (_FIObservationDetails = FIObservationDetails === null || FIObservationDetails === void 0 ? void 0 : FIObservationDetails.Observation) !== null && _FIObservationDetails !== void 0 ? _FIObservationDetails : "",
        savedPhotos: FIObservationImages,
        savedAudio: FIObservationaudios,
        ComplaintInputPlaceHolder: "Enter concerns...",
        onDataReceived: handleComplaintData,
        isFromFinalInspection: true,
        clearDataOnSave: false
    })))), !isViewOnly && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        bottom: 0,
        paddingX: 2,
        paddingBottom: 2,
        bgcolor: "#FFFFFF",
        zIndex: 9
    }, /*#__PURE__*/ React.createElement(MuiBorderBottom, null), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between',
        spacing: 2,
        paddingY: 1
    }, documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data ? /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        size: "medium",
        name: FITaskDetailsButtonVariant.SendBack,
        id: "send-back-btn",
        disabled: ((_getFIButtonDetails = getFIButtonDetails()) === null || _getFIButtonDetails === void 0 ? void 0 : _getFIButtonDetails.buttonName) === FITaskDetailsButtonVariant.SendBack ? (_getFIButtonDetails2 = getFIButtonDetails()) === null || _getFIButtonDetails2 === void 0 ? void 0 : _getFIButtonDetails2.isDisabled : true,
        variant: "contained",
        onClick: function () { return handleClickButton(FITaskDetailsButtonVariant.SendBack); }
    }) : /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        padding: 1,
        style: {
            width: '140px',
            height: '60px'
        }
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        variant: "rounded",
        animation: "wave",
        width: "100%",
        height: '100%'
    })), documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data ? /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        size: "medium",
        name: FITaskDetailsButtonVariant.FinishInspection,
        id: "finish-inpsection-btn",
        disabled: ((_getFIButtonDetails3 = getFIButtonDetails()) === null || _getFIButtonDetails3 === void 0 ? void 0 : _getFIButtonDetails3.buttonName) === FITaskDetailsButtonVariant.FinishInspection ? (_getFIButtonDetails4 = getFIButtonDetails()) === null || _getFIButtonDetails4 === void 0 ? void 0 : _getFIButtonDetails4.isDisabled : true,
        variant: "contained",
        onClick: function () { return handleClickButton(FITaskDetailsButtonVariant.FinishInspection); }
    }) : /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        padding: 1,
        style: {
            width: '140px',
            height: '60px'
        }
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        variant: "rounded",
        animation: "wave",
        width: "100%",
        height: '100%'
    }))))), /*#__PURE__*/ React.createElement(UnsavedChangesPopup, {
        isOpen: openPopup,
        onClosePopup: function (value) { return setOpenPopup(value); },
        onClickNoBtn: onClickLeaveBtn,
        onClickYesBtn: onClickStayBtn
    }), /*#__PURE__*/ React.createElement(FinalInspectorSendBackPopup, {
        isOpen: openSendBackPopup,
        onClosePopup: function () {
            setOpenSendBackPopup(false);
        },
        onClickConfirmBtn: function () {
            sendJobCardForRework();
        },
        onClickCancelBtn: function () {
            setOpenSendBackPopup(false);
        }
    }), /*#__PURE__*/ React.createElement(FinishInspectionPopup, {
        onClosePopup: function () {
            setFinishInspectionPopup(false);
            navigate('/finalInspection');
        },
        successfulPopup: finishInspectionPopup,
        Jcnumber: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy10 = documentDetailsGetById.data) === null || _documentDetailsGetBy10 === void 0 ? void 0 : _documentDetailsGetBy10.SourceDocumentNo
    }));
};
export default FinalInspectorTaskDetails;
